module.exports = __webpack_public_path__ + "img/tree-8.cb5bf0f6.svg";